import { css } from 'src/ui/style/css'
import React, { ComponentType, ReactNode } from 'react'
import { useTheme } from 'src/ui/style/useTheme'
import { NavLink as NavLinkComp } from 'react-router-dom'

type NavLinkProps = {
    children: ReactNode
    to: string
    onClick?: () => void
    className?: string
    activeColor?: string
    uppercase?: boolean
    textAlign?: 'center' | 'right'
}

export const NavLink: ComponentType<NavLinkProps> = ({
    children,
    to,
    onClick,
    className,
    activeColor,
    uppercase = true,
    textAlign = 'center'
}) => {
    const th = useTheme()
    return (
        <NavLinkComp
            to={to}
            className={className}
            css={css`
                color: ${th.colors.tertiary};
                text-transform: ${uppercase ? 'uppercase' : 'none'};
                text-align: ${textAlign};
                &:hover {
                    color: ${th.colors.secondary};
                }
                &.active {
                    color: ${activeColor || th.colors.secondary};
                }
            `}
            onClick={onClick}
            exact
        >
            {children}
        </NavLinkComp>
    )
}
